import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import NavigationContext from '../../Context/NavigationContext';
import './ProductPage.scss';

import ProductDetail from '../../Component/PagesComponent/ProductPage/ProductDetail/ProductDetail';
import productAPI from '../../Data/Product';
import Init from '../../Init/Init';

class ProductPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productCode: '',
            productId: 0,
            fetchType: 0
        }
    }

    static contextType = NavigationContext;

    componentDidMount() {
        let state = this.state;
        let context = this.context;

        let { product_id, code } = context.params;

        state.productCode = code;
        state.productId = product_id;
        state.fetchType = productAPI.enum.fetchType.category;

        this.setState(state);
    }

    componentDidUpdate() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        
        let state = this.state;
        let context = this.context;
        let componentUpdate = false;

        let { product_id, code } = context.params;

        if(state.productCode !== code) {
            state.productCode = code;
            componentUpdate = true;
        }

        if(state.productId !== product_id) {
            state.productId = product_id;
            componentUpdate = true;
        }

        if(state.fetchType !== productAPI.enum.fetchType.category) {
            state.fetchType = productAPI.enum.fetchType.category;
            componentUpdate = true;
        }

        if(componentUpdate) {
            this.setState(state);
        }
    }
    
    componentWillUnmount() {
        this.setState = (state,callback)=>{
            return;
        };

        window.removeEventListener('resize', () => {});
    }

    render() {
        const FontAwesomeIcon = Init.FontAwesomeIcon;

        return (
            <div className="product-page">
                <div className="btn-back-container">
                    <Link className='btn-back' to="/">
                        <FontAwesomeIcon className='btn-back-icon' icon={['fas', 'arrow-left']} />
                        Kembali ke Katalog Kemasan
                    </Link>
                </div>
                <ProductDetail productCode={this.state.productCode} isModal={false} />
            </div>
        );
    }
}

export default ProductPage;